import { useQuery } from '@tanstack/react-query';

import { packagingApi } from 'api/packaging';

export const packagingPurchaseOrderEntityQueryKeys = {
    all: ['packagingPurchaseOrderEntity'],
    detail: (id) => ['packagingPurchaseOrderEntity', 'detail', id],
    items: (id) => ['packagingPurchaseOrderEntity', 'items', id],
};

export const usePackagingPurchaseOrderItems = ({ id, enabled = true } = {}) =>
    useQuery({
        queryKey: packagingPurchaseOrderEntityQueryKeys.items(id),
        queryFn: async () => {
            const response = await packagingApi.getPurchaseOrderDetails(id);
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch packaging purchase order items');
            }
            return response?.data ?? null;
        },
        enabled: Boolean(id) && enabled,
        staleTime: 30 * 1000,
    });
